import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import {
  AppBar,
  Tab,
  Tabs,
  Typography,
  Paper,
  Box,
  Chip,
  useTheme,
  useMediaQuery,
  Container
} from '@material-ui/core';
import {
  Person,
  Loyalty,
  Payment,
  Receipt,
  Group,
  Assessment,
  TrendingUp
} from '@material-ui/icons';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Client from '../../components/Client.js/index.js';
import BonClientVendus from '../../components/BonClientVendus/index.js';
import ListBonClient from '../../components/ListBonClient/index.js';
import TypeClient from '../../components/TypeClient.js/index.js';
import BonClientService from '../../services/BonClientService.js';
import BilanClient from '../../components/BilanClient/index.js';
import ProformaFacture from '../../components/ProformaFacture/index.js';
import ListeProformas from '../../components/ListeProformas/index.js';
import VendreBons from '../../components/VendreBons/index.js';
import StatsBonClient from '../../components/StatsBonClient/index.js';
import BonClientStatsDashboard from '../../components/BonClientStatsDashboard/index.js';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    paddingTop: theme.spacing(1), // Espacement réduit comme dans l'exemple
  },
  appBar: {
    background: 'linear-gradient(135deg, #226D68 0%, #1a524e 100%)',
    borderRadius: '12px 12px 0 0',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%', // Largeur réduite comme dans l'exemple
  },
  tabs: {
    '& .MuiTab-root': {
      minWidth: 120,
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'none',
      color: theme.palette.common.white,
      opacity: 0.8,
      '&.Mui-selected': {
        opacity: 1,
        color: theme.palette.common.white,
      },
      '&:hover': {
        opacity: 1,
        backgroundColor: 'rgba(242, 101, 34, 0.1)',
      },
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#f26522',
      height: 3,
    },
  },
  statCard: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    padding: theme.spacing(3),
    textAlign: 'center',
    transition: 'all 0.3s ease',
    border: `1px solid ${theme.palette.divider}`,
    position: 'relative',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 40px rgba(34, 109, 104, 0.15)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #226D68 0%, #f26522 100%)',
    },
  },
  tabContainer: {
    padding: theme.spacing(4),
    backgroundColor: 'white',
    borderRadius: '0 0 16px 16px',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.08)',
    minHeight: '500px',
    border: `1px solid #e0e0e0`,
    borderTop: 'none',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%', // Largeur réduite comme dans l'exemple
  },
  iconWrapper: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
    background: 'linear-gradient(135deg, #226D68 0%, #2a857e 100%)',
  },
  pendingIcon: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a857e 100%)',
  },
  paidIcon: {
    background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
  },
  unpaidIcon: {
    background: 'linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)',
  },
  chip: {
    borderRadius: '20px',
    fontWeight: 600,
    margin: theme.spacing(0.5),
    fontSize: '0.75rem',
  },
  // NOUVEAU STYLE POUR LE TITRE COMME DANS L'EXEMPLE
  title: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(2), 
    marginTop: theme.spacing(1), 
    fontSize: '2rem', 
  },
  subtitle: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontWeight: 500,
    fontSize: '1.1rem',
  },
  statNumber: {
    fontWeight: 700,
    color: '#226D68',
    fontSize: '2.5rem',
  },
  statLabel: {
    color: '#666',
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    letterSpacing: '1px',
  },
  accentText: {
    color: '#f26522',
    fontWeight: 600,
  },
  statsContainer: {
    marginTop: theme.spacing(3),
  },
  // Nouvelle classe pour le conteneur principal
  pageContainer: {
    minHeight: '100vh',
    paddingTop: theme.spacing(1), 
  },
}));

// Styles pour les tabs comme dans l'exemple
const StyledTabs = withStyles({
  indicator: {
    backgroundColor: '#f26522',
    height: 3,
    borderRadius: 2,
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    marginRight: theme.spacing(1),
    color: 'rgba(255, 255, 255, 0.7)',
    '&$selected': {
      color: '#fff',
    },
    '&:focus': {
      opacity: 1,
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const TabContainer = ({ children, value, index, ...other }) => {
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={classes.tabContainer}
      {...other}
    >
      {value === index && children}
    </div>
  );
};

const Clients = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const auth = useSelector((state) => state.auth);
  
  const [stats, setStats] = useState({
    pending: [],
    paid: [],
    unpaid: []
  });
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);

  // Récupération des feature flags
  const featureFlags = {
    bilanClient: process.env.REACT_APP_FEATURE_FLIPPING_BILAN_CLIENT === "true",
  };

  useEffect(() => {
    refreshStats();
  }, []);

  const refreshStats = async () => {
    setLoading(true);
    try {
      const [pendingResponse, paidResponse, unpaidResponse] = await Promise.all([
        BonClientService.getBonClientPending(auth.nom),
        BonClientService.getStatistiques("PAYER"),
        BonClientService.getStatistiques("NON_PAYER")
      ]);

      setStats({
        pending: pendingResponse.data,
        paid: paidResponse.data,
        unpaid: unpaidResponse.data
      });
    } catch (error) {
      console.error("Erreur lors du chargement des statistiques:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Configuration des tabs avec icônes
  const tabsConfig = [
    { 
      label: "Vendre Bons", 
      icon: <Loyalty />, 
      visible: true, 
      component: <VendreBons /> 
    },
    { 
      label: "Clients", 
      icon: <Person />, 
      visible: true, 
      component: <Client /> 
    },
    { 
      label: "Bons Vendus", 
      icon: <Receipt />, 
      visible: true, 
      component: <BonClientVendus /> 
    },
    { 
      label: "Consultation", 
      icon: <Group />, 
      visible: true, 
      component: <ListBonClient /> 
    },
    { 
      label: "Types Client", 
      icon: <Assessment />, 
      visible: true, 
      component: <TypeClient /> 
    },
    // { 
    //   label: "Bilan", 
    //   icon: <TrendingUp />, 
    //   visible: auth.rol === 'admin' && featureFlags.bilanClient, 
    //   component: <BilanClient /> 
    // },
    { 
      label: "Bilan", 
      icon: <TrendingUp />, 
      visible: auth.rol === 'admin' && featureFlags.bilanClient, 
      component: <StatsBonClient /> 
    },
    { 
      label: "Statistiques", 
      icon: <TrendingUp />, 
      visible: auth.rol === 'admin' && featureFlags.bilanClient, 
      component: <BonClientStatsDashboard /> 
    },
    { 
      label: "Proforma", 
      icon: <Receipt />, 
      visible: auth.rol === 'admin', 
      component: <ProformaFacture /> 
    },
    { 
      label: "Liste Proforma", 
      icon: <Receipt />, 
      visible: auth.rol === 'admin', 
      component: <ListeProformas /> 
    }
  ];

  const visibleTabs = tabsConfig.filter(tab => tab.visible);

  return (
    <div className={classes.pageContainer}>
      <Container maxWidth="xl">
        {/* Titre centré exactement comme dans l'exemple */}
        <Typography variant="h3" className={classes.title}>
          Gestion des Clients
        </Typography>

        {/* Navigation par onglets */}
        <Paper elevation={0}>
          <AppBar position="static" className={classes.appBar}>
            <StyledTabs 
              value={value} 
              onChange={handleChange}
              className={classes.tabs}
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons="auto"
              centered
            >
              {visibleTabs.map((tab, index) => (
                <StyledTab
                  key={index}
                  icon={tab.icon}
                  label={isMobile ? null : tab.label}
                  aria-label={tab.label}
                />
              ))}
            </StyledTabs>
          </AppBar>

          {/* Contenu des onglets */}
          {visibleTabs.map((tab, index) => (
            <TabContainer key={index} value={value} index={index}>
              {tab.component}
            </TabContainer>
          ))}
        </Paper>

        {/* Indicateurs de statut en bas de page */}
        <Box mt={3} display="flex" justifyContent="center" flexWrap="wrap">
          <Chip
            icon={<Payment style={{ color: '#226D68' }} />}
            label={`${stats.pending.length} en attente`}
            className={classes.chip}
            style={{ 
              backgroundColor: '#E8F5E8', 
              color: '#226D68',
              border: '1px solid #226D68'
            }}
          />
          <Chip
            icon={<Payment style={{ color: '#f26522' }} />}
            label={`${stats.paid.length} payés`}
            className={classes.chip}
            style={{ 
              backgroundColor: '#FFF3E0', 
              color: '#f26522',
              border: '1px solid #f26522'
            }}
          />
          <Chip
            icon={<Payment style={{ color: '#dc3545' }} />}
            label={`${stats.unpaid.length} non payés`}
            className={classes.chip}
            style={{ 
              backgroundColor: '#FFEBEE', 
              color: '#dc3545',
              border: '1px solid #dc3545'
            }}
          />
        </Box>

        {/* Footer décoratif */}
        <Box mt={4} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            Système de gestion client • 
            <span style={{ color: '#226D68', fontWeight: 600 }}> Vert</span>
            <span style={{ color: '#f26522', fontWeight: 600 }}> Orange</span>
            {' '}Theme
          </Typography>
        </Box>
      </Container>
    </div>
  );
};

export default Clients;